import { ReactNode } from 'react';

import PasskeyIcon from '@flipster/react/icon/generated/PasskeyIcon';
import { Styles, css } from '@flipster/styled-system/css';

import { authButtonCSSRaw } from '@web/app/[locale]/(web)/_auth/base-styles';
import { usePasskeySupported } from '@web/app/[locale]/(web)/_passkey/misc';

interface Props {
  label?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  css?: Styles;
}

export const ContinueWithPasskey = ({ label, onClick, disabled, css: cssProps }: Props) => {
  const supported = usePasskeySupported();
  return (
    <button
      type='button'
      disabled={!supported || disabled}
      className={css(authButtonCSSRaw, cssProps)}
      onClick={onClick}
    >
      <PasskeyIcon size={20} />
      {label}
    </button>
  );
};
